/**
 * Los totales de una cotizacion, en el mismo orden que el PDF: el descuento
 * sobre el neto, el IVA y el total.
 */
import type { TotalesCotizacion as Totales } from '@bandu/compartido';

import { pesos } from '../../utilidades/formato';

export interface TotalesCotizacionProps {
  totales: Totales;
  descuentoPorcentaje: number;
}

export function TotalesCotizacion({ totales, descuentoPorcentaje }: TotalesCotizacionProps) {
  return (
    <dl className="totales-pedido">
      {descuentoPorcentaje > 0 ? (
        <>
          <div>
            <dt>Subtotal neto</dt>
            <dd className="num">{pesos(totales.subtotalNeto)}</dd>
          </div>
          <div>
            <dt>Descuento {descuentoPorcentaje}%</dt>
            <dd className="num">-{pesos(totales.descuentoNeto)}</dd>
          </div>
        </>
      ) : null}
      <div>
        <dt>Total neto</dt>
        <dd className="num">{pesos(totales.totalNeto)}</dd>
      </div>
      <div>
        <dt>IVA 19%</dt>
        <dd className="num">{pesos(totales.iva)}</dd>
      </div>
      <div className="total">
        <dt>Total</dt>
        <dd className="num">{pesos(totales.total)}</dd>
      </div>
    </dl>
  );
}
